export enum AssessmentControlStatus {
  Draft,
  Rejected,
  Approved,
  Expired,
}

export const displayAssessmentControlStatus = (
  value: AssessmentControlStatus,
) => {
  switch (value) {
    case AssessmentControlStatus.Draft:
      return 'Draft';
    case AssessmentControlStatus.Rejected:
      return 'Rejected';
    case AssessmentControlStatus.Approved:
      return 'Approved';
    case AssessmentControlStatus.Expired:
      return 'Expired';
  }
};
